<template>
  <form enctype="multipart/form-data" class="subscribe-form subscribe-form_dark">
    <input type="hidden" name="TYPE_FORM" value="subscribe">
    <input type="hidden" name="Theme" :value="themeValue">
    <input type="hidden" name="PORTFOLIO" value="Creative Commerce">

    <div class="subscribe-form__value">
      <input type="email" name="Email" placeholder="E-mail" class="subscribe-form__input input-email">

      <button type="submit" class="button">
        Subscribe
        <IconArrow/>
      </button>
    </div>

    <div class="subscribe-form__agree">
      <div class="checkbox-input">
        <input type="checkbox" name="AGREEMENT" :id="checkboxId" class="checkbox">
        <label :for="checkboxId">
          I want to receive exclusive content from Creative&nbsp;Commerce: insider guides and personalized tips for my store.
        </label>
      </div>
    </div>

  </form>
</template>

<style lang="scss">
.subscribe-form {
  &_dark {
    .subscribe-msg {
      color:#000;
    }
  }
  &__value {
    display:flex;
    gap:10px;

    @include xs {
      flex-direction:column;
    }
  }

  &__input {
    height:3.5rem;
  }

  &_dark &__input {
    border-color:rgba(0,0,0,.2);
    color:#000;

    &:focus {
      border-color:rgba(0,0,0,.4);
    }
  }

  &__agree {
    margin:1.5rem 0 0;

    @include md {
      margin-top:1rem;
    }
  }

  &_dark &__agree {
    .checkbox-input {
      input {
        display:none;

        & + label {
          color: rgba(27, 28, 30, 0.7);

          &:before {
            border: 1px solid rgba(27, 28, 30, 0.7);
          }

          &:after {
            filter:brightness(0) invert(0);
          }

          a {
            color: var(--color-main);
            border-bottom: 1px solid rgba(0,0,0, 0.4);
            text-decoration: none;

            &:hover {
              border-color:rgba(0,0,0,.8);
            }
          }
        }

        &:checked + label {
          &:after {
            filter:brightness(0) invert(1);
          }
          &:before {
            background: var(--color-main);
            border-color:var(--color-main);
          }
        }
      }
    }

  }

  .button {
    flex:none;
    height:3.5rem;

    @include md {
      width:initial;
    }
  }
}
</style>

<script setup>
import { onMounted, computed } from 'vue'
import JustValidate from 'just-validate'
import IconArrow from '@/components/icons/IconArrow.vue'

const props = defineProps({
  theme: {
    type: String,
    default: ''
  },
  id: {
    type: Number,
    default: 0
  }
})

const themeValue = computed(() => props.theme ? props.theme : 'None')
const checkboxId = computed(() => `subscribe-agree-${props.id}`)

onMounted(() => {
  const forms = document.querySelectorAll('.subscribe-form')

  forms.forEach((form, index) => {
    const emailInput = form.querySelector('.input-email')
    const checkbox = form.querySelector('.checkbox')

    if (!emailInput || !checkbox) return

    let msgEl = form.querySelector('.subscribe-msg')
    if (!msgEl) {
      msgEl = document.createElement('div')
      msgEl.className = 'subscribe-msg'
      form.appendChild(msgEl)
    }

    const validation = new JustValidate(form)

    validation
        .addField(emailInput, [
          { rule: 'required', value: true, errorMessage: 'Please enter your email' },
          { rule: 'email', value: true, errorMessage: 'Email format is invalid' }
        ])
        .addField(checkbox, [
          { rule: 'required', value: true, errorMessage: 'You must agree to Terms & Privacy Policy' }
        ])
        .onSuccess((event) => {
          let formData = new FormData(event.target)
          let xhr = new XMLHttpRequest()

          form.classList.add('loading')

          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                msgEl.textContent = 'Thank you for subscribing!'
                event.target.reset()
              } else {
                msgEl.textContent = 'Something went wrong. Please try again.'
              }
              form.classList.remove('loading')
            }
          }

          xhr.open('POST', 'https://creativecommercelabs.com/zendesk/subscribe.php', true)
          xhr.send(formData)
        })
  })
})
</script>
